import '../scss/style.scss';
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;
require('./utils/functions');
require('bootstrap/dist/js/bootstrap');
require('jquery.scrollto/jquery.scrollto');
require('./libs/slick.min');
require('./libs/jquery.fancybox');

require('./animated');
require('./main-slider');
require('./navbar-scroll');
require('./scroll');
require('./homepage/advantages');
require('./homepage/videos');
require('./homepage/distribution');
require('./serial-number');
require('./faq');
require('./comparison');
require('./comparison-widget');
require('./product-comparison');
require('./quick-search');
// require('./shops-map');